import isProduction from 'app/common/lib/isProduction'

// Статическое включение/выключение некоторого функционала.
// Все флаги в одном месте: чтобы включить/выключить фичу — правим здесь.

// dev-only функционал: включён везде, кроме production-сборки
const devOnly = !isProduction()

export const features = {
  root: {
    // раздел "Склад" в меню и роутинге
    warehouse: devOnly,
  },
  dishes: {
    // колонка "Уровень готовности"
    processingLevel: devOnly,
    // колонка с выбором единицы измерения
    unit: devOnly,
    // кнопки перехода в техкарту и КБЖУ в колонке типа продукции + блокировка route техкарты
    kbzhuAndTechCard: devOnly,
    // скачивание техкарты (кнопка над таблицей, появляется при наличии выбранных блюд)
    techCardDownload: devOnly,
    // отображение штрихкода в колонке "Наименование"
    barcode: devOnly,
    // массовое изменение типов продукции, групповая кнопка в toolbar (участвуют выделенные чекбоксом блюда)
    selectedDishesTypesChange: devOnly,
  },
}
